import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useGetViewPollParticipants } from 'api/post'
import { PollAnswerOption } from 'components-ref/atoms'
import { Modal } from 'components-ref/molecules/modal/modal'
import {
    ViewPollFooter,
    ViewPollParticipantsUsersList
} from 'components-ref/molecules/view-poll-participants'
import { type ISelectedAnswerPoll } from 'types/interfaces/ISelectedAnswerPoll'
import { type IUserCard } from 'types/interfaces/IUserCard'

interface ViewPollParticipantsModalProps {
    onClose: () => void
    pollId: string
    answerSelected: ISelectedAnswerPoll
}

export const ViewPollParticipantsModal = ({
    pollId,
    answerSelected,
    onClose
}: ViewPollParticipantsModalProps) => {
    const { t } = useTranslation()

    const { data, isLoading } = useGetViewPollParticipants(
        pollId,
        answerSelected.answerId
    )

    const users: IUserCard[] = data
        ? data.pages.flatMap(page => page.data.results)
        : []

    return (
        <Modal
            title={t('pollParticipants')}
            onClose={onClose}
            hasShadow={true}
            closeOnLayerClick={true}
            isLayerTransparent={false}
            paddingBottom={0}
            hideCloseIcon
        >
            <MarginWrapper>
                <PollAnswerOption
                    answerKey={answerSelected.key}
                    optionCount={answerSelected.count}
                    total={answerSelected.total}
                    text={answerSelected.text}
                />

                <ViewPollParticipantsUsersList
                    pollId={pollId}
                    answerId={answerSelected.answerId}
                />

                <ViewPollFooter
                    onClose={onClose}
                    answerId={answerSelected.answerId}
                    users={users}
                    isLoadingUsers={isLoading}
                />
            </MarginWrapper>
        </Modal>
    )
}

const MarginWrapper = styled.div`
    display: grid;
    margin-top: 2rem;
    gap: 2rem;
    overflow:visible;
`